import {inject, InjectionToken, REQUEST_CONTEXT} from "@angular/core";
import {Lottery} from "./model/lottery";

const ONE_MINUTE = 60;
const ONE_HOUR = 3600;
const HALF_DAY = 43200;
const ONE_DAY = 86400;
const ONE_WEEK = 604800;

export type SsrRequestContext = {
  cacheDuration: number;
};

export function injectSsrRequestContext(): SsrRequestContext | undefined {
  return inject(REQUEST_CONTEXT, {optional: true}) as SsrRequestContext | undefined;
}

export function getApartmentCacheDuration(apartment: Lottery): number {
  if (apartment.status === 'closed') {
    return ONE_WEEK;
  }

  const msUntilDeadline = new Date(apartment.endDate).getTime() - Date.now();
  const daysUntilDeadline = msUntilDeadline / (1000 * 60 * 60 * 24);

  if (daysUntilDeadline <= 1) {
    return ONE_HOUR;
  }

  if (daysUntilDeadline <= 7) {
    return HALF_DAY;
  }

  return ONE_DAY;
}

export {ONE_MINUTE, ONE_HOUR, HALF_DAY, ONE_DAY, ONE_WEEK};
